/* eslint-disable react/prop-types */ function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { Badge } from 'react-bootstrap';
import toLower from 'lodash/toLower';
import Icon from '../../icon/Icon';
import text from '../../../text';
var IndicatorSeparator = function(_param) {
    var inputValue = _param.inputValue, props = _object_without_properties(_param, [
        "inputValue"
    ]);
    var existingOption = props.options.find(function(option) {
        return option.name && toLower(option.name) === toLower(inputValue) && !option.__isNew__;
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, inputValue && /*#__PURE__*/ React.createElement(Badge, {
        className: "inverted center-content mr-2",
        variant: existingOption ? 'warning' : 'info'
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "mr-1",
        icon: existingOption ? 'triangular-exclamation' : 'information'
    }), text(existingOption ? 'similar' : 'new')), "|");
};
export default IndicatorSeparator;
